import { some, negate, identity } from 'lodash/fp';
export var someFalse = some(negate(identity));
export default someFalse;